import { getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { AddFrameCommand } from './AddFrameCommand';
import { CommandFunction } from './Command';
import { createTextFrame } from 'state/actions';

export class AddTextFrameCommand extends AddFrameCommand {
  execute(firstTime?: boolean): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { app, flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const frame = await createTextFrame(app, flyer, false, layer);
      this.dispatchWithFrame(
        dispatch,
        frame,
        layer,
        app.openedModals.length > 0,
        firstTime
      );
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/AddTextFrameCommand.ts